<template>
  <div class="row">
    <div class="col-12">
      <h5>Tags de {{this.username()}}</h5>
      <ul>
        <li style="color: white; cursor: pointer;" v-for="tag in tagsCollection" v-on:click="listNotesFor(tag)">
          {{tag.name}}
        </li>
      </ul>

      <form v-on:submit.prevent="createTag" v-if="false">
        <div class="form-group">
          <label for="inputUsername">Criar tag</label>
          <input type="text" class="form-control" v-model="newTagName">
          <button type="submit" class="btn btn-primary">Criar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tags',
  data: () => {
    return {
      tags: [],
      newTagName: ''
    }
  },
  computed: {
    tagsCollection () {
      return this.tags
    }
  },
  methods: {
    username () {
      return this.$cookies.get('user_name')
    },
    listNotesFor (tag) {
      console.log(tag)
    },
    createTag () {
      this.$http.post(`${this.$root.base_url}/tags/create`, { name: this.newTagName }, { headers: { Token: this.$cookies.get('api_token') } })
        .then(response => {
          if (response.body.data) {
            this.$set(this.tags, this.tags.length, { id: response.body.data.id, name: this.newTagName })
            this.newTagName = ''
          }
        })
        .catch(e => console.error(e.stack))
    }
  },

  mounted(){
    let successCallback = (response) => {
      if (response.body.data) {
        this.tags = response.body.data
      }
    }

    let errorCallback = (response) => {
      debugger
    }

    this.$http.get(`${this.$root.base_url}/tags`, { headers: { Token: this.$cookies.get('api_token') } }).then(successCallback, errorCallback)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Tags.vue